<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'applyAddCK',
    components: {
      baseEdit,
    },
  };
</script>
